"use client";

import { useTranslations } from "next-intl";
import React, { ComponentPropsWithRef, forwardRef } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

import { controlledRadio } from "@/components/ui/Form/Filters/FilterUtils";
import Radio from "@/components/ui/Form/Radio/Radio";

export interface RadioBaseProps extends ComponentPropsWithRef<"input"> {
  name: string;
  filter: string;
  displayInSearchBar?: boolean;
  values?: (string | number)[] | undefined;
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
  availableValues?: (string | number)[] | undefined;
}
const RadioBase = forwardRef<HTMLInputElement, RadioBaseProps>(
  ({ name, filter, displayInSearchBar = false, field, fieldState, values, availableValues, ...rest }, ref) => {
    const t = useTranslations();

    return (
      <div className={`flex gap-xs pb-m`}>
        {values?.map((value, index) => {
          const filedUID = `filter-${name}-${value}`;
          return (
            <Radio
              className={`p-s py-xs rounded-lg border ${field?.value?.includes(value as string) ? "bg-gold-gradient border-transparent" : " border-gray-10"}`}
              checked={field?.value?.includes(value as string) ?? false}
              key={filedUID}
              label={t(`filter.label.${name}.${value as string}`)}
              name={name}
              value={value as string}
              onChange={(event) => controlledRadio(field, event)}
              //disabled={availableValues && availableValues.length > 0 ? !availableValues?.includes(value) : false}
            />
          );
        })}
      </div>
    );
  },
);
RadioBase.displayName = "RadioBase";
export default RadioBase;
